/**
 *
 * @param {unknown} value
 * @param {string} type
 * @returns {boolean}
 */
export function isType(value, type) {
  const str = Object.prototype.toString.call(value);
  return str.indexOf('[object') === 0 && str.indexOf(type) > -1;
}

export function isElement(value) {
  return isType(value, 'Element') || isType(value, 'Fragment');
}

export function isNodeList(value) {
  return isType(value, 'NodeList');
}

export function getArrayOfElements(targets) {
  if (isElement(targets)) return [targets];
  if (isNodeList(targets)) return [...targets];
  if (Array.isArray(targets)) return targets;

  return [...document.querySelectorAll(targets)];
}
